import clsx from 'clsx';
import React, { forwardRef, useContext, useMemo } from 'react';
import { OverrideButtonsContainer } from '../button/regular-button';
import { ModalContext, ScrollContext } from './modal-context';
import styles from './styles/modal-footer.module.css';
/**
 * `<ModalFooter>` - Обёртка для контента футера модального окна.
 * Предоставляет стили для контента.
 */
export const ModalFooter = /*#__PURE__*/forwardRef(function ModalFooter({
  children,
  className = '',
  vertical,
  ...props
}, ref) {
  const {
    variant = 'simple',
    sticky,
    size
  } = useContext(ModalContext);
  const {
    scrollBottom
  } = useContext(ScrollContext);
  const modalFooterClass = useMemo(() => clsx(styles.modalFooter, styles[variant], vertical ? styles.column : '', sticky ? styles.sticky : '', scrollBottom ? styles.onScroll : '', className), [variant, sticky, scrollBottom, className, vertical]);
  return /*#__PURE__*/React.createElement("div", {
    className: modalFooterClass,
    ref: ref,
    ...props
  }, /*#__PURE__*/React.createElement(OverrideButtonsContainer, {
    hard: {
      wide: size === 's'
    }
  }, children));
});